import { ProjectsApi } from 'osep-generator-service-client-v1';
import { useApiConfig } from '../useApiConfig';

function useGenerateProjectMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const generateProject = async (projectId: string) => {
    const config = await getApiConfig();
    const projectsApi = new ProjectsApi(config, undefined, axiosInstance);

    const response = await projectsApi.generateProject(projectId);

    return response.data;
  };

  return { generateProject };
}

export default useGenerateProjectMutation;
